import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_SERVICE_ROUTER } from "../../../services/api-config";

export enum ServiceStatusCode {
  INACTIVE = 0,
  ACTIVE = 1,
  DELETED = 2,
}

export interface Service {
  id: number;
  branch_id: number;
  code: string;
  name: string;
  description?: string;
  image_url?: string;
  status: ServiceStatusCode;
  created_at: string;
  updated_at: string;
  service_variant_id?: number;
  variant_names?: string[];
}

export interface ServiceListResponse {
  list: Service[];
  total_record: number;
  limit?: number;
}

export interface ServiceListFilters {
  status?: number;
  branch_id?: number;
}

export interface CreateServicePayload {
  branch_id: number;
  code: string;
  name: string;
  variant_names?: string[];
  description?: string;
  image_url?: string;
  status?: ServiceStatusCode;
}

export interface UpdateServicePayload {
  code?: string;
  name?: string;
  description?: string;
  image_url?: string;
  status?: ServiceStatusCode;
}

export interface ChangeServiceStatusPayload {
  status: ServiceStatusCode;
}
export const ServiceService = {
  list: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<ServiceListResponse>({
        projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
      });
      return {
        fetch: (params: ServiceListFilters = { status: -1 }) =>
          request({
            endPoint: API_SERVICE_ROUTER.API_LIST_SERVICE,
            data: params,
          }),
        response: baseResponse,
        loading: loading,
      };
  },

  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<Service>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (payload: CreateServicePayload) =>
        request({
          endPoint: API_SERVICE_ROUTER.API_CREATE,
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    };
  },

  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<Service>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (id: number, payload: UpdateServicePayload) =>
        request({
          endPoint: API_SERVICE_ROUTER.API_UPDATE_SERVICE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    };
  },

  changeStatus: () => {
    const { request, baseResponse, loading } = useFetchData.Post<Service>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (id: number, payload: ChangeServiceStatusPayload) =>
        request({
          endPoint: API_SERVICE_ROUTER.API_CHANGE_STATUS_SERVICE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  detail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<Service>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (id: number) =>
        request({
          endPoint: API_SERVICE_ROUTER.API_DETAIL_SERVICE(id),
        }),
      response: baseResponse,
      loading: loading,
    }
  },
};

export default ServiceService;
